<template>
  <div>
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="row">
          <div class="col-8 mb-0 mb-xl-0">
            <h4 class="font-weight-bold">System Users</h4>
          </div>
          <div class="col-4">
            <router-link class="btn btn-primary btn-icon-text text-white float-right" to="/admin/create">
              <span class="h4 text-white">Create Admin </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table id="user-listing" class="table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Mobile Number</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.uuid">
            <td>{{ user.fullName }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.mobileNumber }}</td>
            <td>
              <span class="badge badge-success">
                Active
              </span>
            </td>
            <td>
              <router-link :to="'/admin/manage/' + user.uuid" class="btn btn-md btn-outline-primary ml-2" data-toggle="tooltip" title="Manage Admin">
                <i class="fa fa-cog"></i>
              </router-link>
              <button class="btn btn-md btn-outline-danger ml-2" @click="deleteUser(user.uuid)" data-toggle="tooltip" title="Delete Admin">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: "UserList",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      users: []
    };
  },
  methods: {
    async getUsers() {
      try {
        const response = await api.doGet('/api/admin/list');
        if (response.status === "00") {
          this.users = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch admin list");
        }
      } catch (error) {
        console.error("Error fetching admin list:", error);
        this.toast.error("An error occurred while fetching admin list");
      }
    },
    async deleteUser(uuid) {
      if (confirm("Are you sure you want to delete this admin?")) {
        try {
          const response = await api.doPost('/api/admin/delete', { uuid });
          if (response.status === "00") {
            this.toast.success(response.message || "Admin deleted successfully");
            this.getUsers();
          } else {
            this.toast.error(response.message || "Failed to delete admin");
          }
        } catch (error) {
          console.error("Error deleting admin:", error);
          this.toast.error("An error occurred while deleting the admin");
        }
      }
    }
  },
  mounted() {
    this.getUsers();
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}

.badge {
  padding: 8px 12px;
  font-size: 0.85em;
}

.badge-success {
  background-color: #28a745;
  color: white;
}


.btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  color: #fff;
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: #fff;
}

[data-toggle="tooltip"] {
  cursor: pointer;
}
</style> 